import { Capacitor } from '@capacitor/core';
import { useEffect, useState } from 'react';

const platform = Capacitor.getPlatform(); // 'ios' | 'android' | 'web'
const isNative = Capacitor.isNativePlatform();

/**
 * Returns stable platform flags.
 * - isMobile: true when running natively OR when viewport < 768px
 * - isNative: true only inside a Capacitor native shell
 * - isIOS / isAndroid: platform-specific
 */
export function usePlatform() {
  const [isMobileBreakpoint, setIsMobileBreakpoint] = useState(
    typeof window !== 'undefined' ? window.innerWidth < 768 : false
  );

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 767px)');
    const handler = (e: MediaQueryListEvent) => setIsMobileBreakpoint(e.matches);
    mq.addEventListener('change', handler);
    setIsMobileBreakpoint(mq.matches);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return {
    isMobile: isNative || isMobileBreakpoint,
    isNative,
    isIOS: platform === 'ios',
    isAndroid: platform === 'android',
    isWeb: platform === 'web',
  };
}
